import container from 'modules/section-content';
import domify from 'domify';
import 'bootstrap';
import page from 'page';
import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import splash from './identity-glossary-page.pug';
import { App } from './containers';
import metadata from './metadata.json';
import { scrollToDOMElement } from './domUtils';
import { findById } from './utils';

export default function register() {
  page('/identity-glossary', initial);
  page('/identity-glossary/:term', initial);

  page.exit('/identity-glossary', unMountApp);
  page.exit('/identity-glossary/:term', unMountApp);
}

function initial(ctx, next) {
  const view = domify(splash());

  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view })
  };
  container.render(renderOptions);
  const { glossaryData } = window.GLOSSARY_DATA || {};
  const glossaryItem = findById(glossaryData, ctx.params.term) || {};
  const props = Object.assign({ glossaryData, glossaryItem }, { route: ctx.params.term || 'home' });
  render(<App {...props} />, document.querySelector('.glossary-app'));

  if (ctx.hash !== '') {
    const el = document.getElementById(ctx.hash);
    const searchBarHeight = document.querySelector('.search-bar').offsetHeight;
    scrollToDOMElement(el, searchBarHeight);
  }
  return next();
}

function unMountApp(ctx, next) {
  unmountComponentAtNode(document.querySelector('.glossary-app'));
  return next();
}



// WEBPACK FOOTER //
// ./src/pages/identity-glossary/identity-glossary.js